<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <filter-by-status-header

            :title="'Văn bản đến (Vai trò đã bị khóa)'"
          />
        </template>
      </headerTemplate>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div
                  class="flex-row flex-left__top margin-right-10 custom-label__input"
                  v-bind:style="{ 'width': '100%', 'justify-content': 'center' }"
                >
                  <span class="label-input">Chọn role: </span>
                  <selector
                    @searchDocCV="searchDocCV"
                    @searchDocVT="searchDocVT"
                  />
                </div>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                  >
                    <div slot="spinner">
                      Vui lòng chọn role đã khóa để truy xuất văn bản
                    </div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>
    </template>
  </listTemplate>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
import listTemplate from "../../common/list";
import headerTemplate from "../../../components/header/main-header.vue";
import searchTemplate from "../../common/search";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vbDenMixin from "./vbDenMixin";
import FilterByStatusHeader from "../../doc-out/components/filter-by-status-header";
import Selector from "../../common/locked-role-select-branch.vue";

export default {
  components: {
    Selector,
    FilterByStatusHeader,
    InfiniteLoading,
    listTemplate,
    headerTemplate,
    searchTemplate,
    VuePerfectScrollbar,
    subHeader: () => import("../../../components/main/sub-header.vue"),
  },

  mixins: [vbDenMixin],

  created() {
    this.$store.commit("setUserDeptRoleLocked", null);
  },

  methods: {
    searchTdhvpDoc() {
      this.$router.push({
        name: "tdhvpDocInIndex",
        params: this.$route.params
      });
    },

    searchLockedRoleDocIn() {
      this.$router.push({
        name: "lockedRoleDocInIndex",
        params: this.params
      });
    },
  }
};
</script>
<style scoped>
#searchBox {
  position: relative;
  width: 100%;
}

.advance-search {
  font-size: 17px;
  color: #005eb1;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.icon-very__small {
  height: 14px;
  padding-top: 4px;
}

.icon-info {
  background-color: #f0c330;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-top: -1px;
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/locked-role/lockedRoleDocInIndex.vue